/** @type {string} */
const buttonString = 'button';
export default buttonString;
